import moment from "moment";
import { ICustomReactSelectOption } from "../core/types/elements/ICustomReactSelectOption";

const watchingAppointmentKey: string[] = ["startTime", "endTime", "techIds"];

const itemExpenseType = ["Travel", "TravelOT", "Labor", "LaborOT"];

const expenseDefaultForm = {
  quantity: undefined,
  price: undefined,
  description: "",
  startMileage: undefined,
  endMileage: undefined,
  item: undefined,
  type: undefined,
  startTime: undefined,
  endTime: undefined,
};

const defaultTime = "00:00:00";
const today = new Date();
const endTime = moment(today).add(1, "hour").toDate();
const curremntAppointmentConst = {
  title: "New Appointment",
  startTime: new Date(),
  endTime: new Date(),
  active: true,
};
const defaultItemExpense = {
  label: "Default Config",
  value: "0",
};

const quoteWOStatuses: ICustomReactSelectOption = { label: "Without WO", value: "0" };

export {
  expenseDefaultForm,
  watchingAppointmentKey,
  defaultTime,
  today,
  endTime,
  itemExpenseType,
  curremntAppointmentConst,
  defaultItemExpense,
  quoteWOStatuses,
};
